import React from "react";
import jsPDF from "jspdf";

import KeysManagementService from "../../../services/Celcoin/keysManagementService";
import { getTranslations } from "../../../services/languageUtils";
import { isMutual } from "../../../utils/isMutual";
import { isMtBank } from "../../../utils/isMtBank";
import { canRefund, isRefundEntry } from "../../../utils/refund";
import { buildReceiptFields } from "../../../utils/receipt";
import logo from "../../../assets/imgs/logo_new.png";
import logoPmi from "../../../assets/imgs/PMI.png";

const bankNames = {
  "001": "Banco do Brasil",
  "003": "Banco da Amazônia",
  "004": "Banco do Nordeste",
  "007": "BNDES",
  "010": "Credicoamo",
  "011": "C.Suisse Brasil",
  "012": "Banco Inbursa",
  "014": "Natixis",
  "015": "UBS Brasil",
  "016": "Banco BNY Mellon",
  "017": "BNY Mellon",
  "018": "Banco Tricury",
  "021": "Banestes",
  "024": "Banco Bandepe",
  "025": "Banco Alfa",
  "029": "Banese",
  "033": "Santander",
  "036": "Banco Bradesco BBI",
  "037": "Banco do Estado do Pará",
  "040": "Banco Cargill",
  "041": "Banrisul",
  "047": "Banco do Estado de Sergipe",
  "060": "Confidence Câmbio",
  "062": "Hipercard",
  "063": "Banco Bradescard",
  "064": "Goldman Sachs do Brasil",
  "065": "Banco AndBank",
  "066": "Banco Morgan Stanley",
  "070": "Banco de Brasília (BRB)",
  "074": "Banco J. Safra",
  "075": "Banco ABN Amro",
  "076": "Banco KDB",
  "077": "Banco Inter",
  "078": "Haitong Banco",
  "079": "Banco Original do Agronegócio",
  "080": "BNP Paribas",
  "081": "BBN Banco",
  "082": "Banco Topázio",
  "083": "Banco da China Brasil",
  "084": "Unicred",
  "085": "Cooperativa Ailos",
  "089": "Banco Genial",
  "091": "Banco Paulista",
  "092": "BRK S.A.",
  "093": "PAGSEGURO",
  "094": "Banco Finaxis",
  "095": "Banco Confidence",
  "096": "Banco B3",
  "097": "Banco Cooperativo Unicred",
  "098": "Credialiança",
  "099": "Uniprime Central",
  100: "Planner Corretora",
  101: "Renascença DTVM",
  102: "XP Investimentos",
  104: "Caixa Econômica Federal",
  107: "Banco BOCOM BBM",
  108: "PortoCred",
  121: "Banco Agibank",
  136: "UNICRED",
  133: "Cresol",
  237: "Bradesco",
  241: "Easynvest",
  260: "Nu Pagamentos (Nubank)",
  265: "Banco Fator",
  290: "PagBank",
  341: "Itaú Unibanco",
  380: "PicPay",
  389: "Banco Mercantil do Brasil",
  394: "Banco Bradesco Financiamentos",
  399: "HSBC",
  422: "Banco Safra",
  456: "Banco MUFG Brasil",
  464: "Banco Sumitomo Mitsui Brasileiro",
  473: "Banco Caixa Geral - Brasil",
  477: "Citibank",
  479: "Banco ItauBank",
  487: "Deutsche Bank",
  488: "JPMorgan Chase",
  492: "Banco NMB Postbank",
  494: "Banco La Nacion Argentina",
  495: "Banco de La Republica Oriental del Uruguay",
  505: "Banco Credit Suisse",
  545: "Senso",
  600: "Banco Luso Brasileiro",
  604: "Banco Industrial",
  623: "Banco Pan",
  626: "Banco Ficsa",
  630: "Banco Intercap",
  633: "Banco Rendimento",
  634: "Banco Triângulo (Banco Triângulo S.A.)",
  637: "Banco Sofisa",
  641: "Banco Alvorada",
  643: "Banco Pine",
  652: "Itaú Unibanco Holding",
  653: "Banco Indusval",
  654: "Banco A.J. Renner",
  681: "MT IP S.A.",
  707: "Banco Daycoval",
  712: "Banco Ourinvest",
  745: "Banco Citibank",
  746: "Banco Modal",
  748: "Sicredi",
  751: "Banco BGE",
  752: "BNP Paribas",
  753: "NBC Bank Brasil",
  754: "Banco Sistema",
  755: "Bank of America Merrill Lynch",
  756: "Sicoob",
  757: "KEB Hana Bank Brasil",
};

class Item extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      translations: {},
      pixKey: "",
    };
  }

  componentDidMount() {
    this.loadTranslations();
    this.updateKeys();
  }

  updateKeys() {
    let that = this;
    KeysManagementService.index()
      .then((res) => {
        const keys = Array.isArray(res?.data)
          ? res.data
          : res?.data?.body?.listKeys || [];
        that.setState({ pixKey: keys[0]?.key || "" });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  loadTranslations = async () => {
    const translations = await getTranslations(
      localStorage.getItem("language") || "pt",
    );
    this.setState({ translations });
  };

  getDate(date) {
    return new Date(date).toLocaleDateString("pt-BR", { timeZone: "UTC" });
  }

  getHour(dateStr) {
    const date = new Date(dateStr);
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();

    const formatted = `${hours < 10 ? "0" + hours : hours}:${minutes < 10 ? "0" + minutes : minutes}`;
    return formatted;
  }

  formatToBRL(number) {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(number);
  }

  refund(event, item) {
    // A linha inteira dispara o download do comprovante; sem parar a
    // propagação o clique em "Devolver" baixaria um PDF junto.
    event.stopPropagation();
    if (this.props.onRefund) {
      this.props.onRefund(item);
    }
  }

  renderRefundButton(item) {
    if (!this.props.onRefund || !canRefund(item)) {
      return null;
    }

    return (
      <button
        type="button"
        title="Devolver o Pix recebido, total ou parcialmente"
        onClick={(event) => this.refund(event, item)}
        style={{
          backgroundColor: "white",
          border: "1px solid #1c787e",
          color: "#1c787e",
          borderRadius: "6px",
          padding: "4px 10px",
          fontSize: "13px",
          fontWeight: "bold",
          cursor: "pointer",
          whiteSpace: "nowrap",
        }}
      >
        Devolver
      </button>
    );
  }

  getBankName(code) {
    return code ? bankNames[code.toString().padStart(3, "0")] || code + "" : "";
  }

  openSlideOver(item) {
    const doc = new jsPDF();
    const green = [23, 137, 89];
    const startX = 30;
    let currentY = 50;
    const pageWidth = doc.internal.pageSize.getWidth();

    const fields = buildReceiptFields(item);
    const value = this.formatToBRL(fields.amount);
    const transferDate = item?.entry_date
      ? new Date(item.entry_date).toLocaleString("pt-BR", { hour12: false })
      : "--";

    const counterparty = item?.counterparty || {};
    const counterpartyDocument = counterparty?.document || {};
    const counterpartyName = counterparty?.name || "--";
    const counterpartyDoc = counterpartyDocument?.number || "--";
    const counterpartyDocType = counterpartyDocument?.type || "CPF/CNPJ";
    const counterpartyBank = counterparty?.bankName || "--";
    const counterpartyBranch = counterparty?.branch || "--";
    const counterpartyAccount = counterparty?.account || "--";
    const counterpartyIspb = counterparty?.ispb || "--";
    const counterpartyAccountType = counterparty?.accountType || "--";

    const externalCode = item?.external_code || "--";
    const description = this.formatReceiptDescription(item);
    const title = fields.title;

    const imgWidth = 50;
    const imgHeight = 30;
    const imgX = (pageWidth - imgWidth) / 2;
    if (sessionStorage.getItem("emailUser")?.includes("@pmi.tech")) {
      doc.addImage(logoPmi, "PNG", imgX, 10, imgWidth, imgHeight);
    } else {
      doc.addImage(logo, "PNG", imgX, 10, imgWidth, imgHeight);
    }

    doc.setFontSize(20);
    doc.setTextColor(...green);
    doc.setFont(undefined, "bold");
    doc.text(title, startX, currentY);
    currentY += 8;

    doc.setFontSize(12);
    doc.setTextColor(60);
    doc.setFont(undefined, "normal");
    doc.text(transferDate, startX, currentY);
    currentY += 6;

    doc.line(startX, currentY, pageWidth - startX, currentY);
    currentY += 10;

    doc.setFontSize(17);
    doc.setFont(undefined, "bold");
    doc.setTextColor(...green);
    doc.text("Identificação", startX, currentY);
    currentY += 7;

    doc.setFontSize(13);
    doc.setTextColor(50);
    doc.setFont(undefined, "normal");
    doc.text(`${fields.idLabel}: ${fields.transactionId}`, startX, currentY);
    currentY += 6;
    doc.text(`EndToEnd: ${fields.endToEndId}`, startX, currentY);
    currentY += 6;
    if (fields.originalEndToEndId) {
      doc.text(
        `EndToEnd do Pix original: ${fields.originalEndToEndId}`,
        startX,
        currentY,
      );
      currentY += 6;
    }
    currentY += 4;

    doc.setFontSize(18);
    doc.setFont(undefined, "bold");
    doc.setTextColor(...green);
    doc.text("Valor", startX, currentY);
    currentY += 9;

    doc.setFontSize(16);
    doc.setTextColor(0);
    doc.setFont(undefined, "normal");
    doc.text(value, startX, currentY);
    currentY += 10;

    doc.setFontSize(13);
    doc.setTextColor(50);
    doc.text(`Descrição: ${description}`, startX, currentY);
    currentY += 10;

    doc.setFontSize(17);
    doc.setFont(undefined, "bold");
    doc.setTextColor(...green);
    doc.text(fields.counterpartyLabel, startX, currentY);
    currentY += 7;

    doc.setFontSize(13);
    doc.setTextColor(50);
    doc.setFont(undefined, "normal");
    doc.text(`Nome: ${counterpartyName}`, startX, currentY);
    currentY += 6;
    doc.text(`Doc: ${counterpartyDoc}`, startX, currentY);
    currentY += 6;
    doc.text(`Banco: ${counterpartyBank}`, startX, currentY);
    currentY += 6;
    doc.text(`ISPB: ${counterpartyIspb}`, startX, currentY);
    currentY += 6;
    doc.text(`Agência: ${counterpartyBranch}`, startX, currentY);
    currentY += 6;
    doc.text(`Conta: ${counterpartyAccount}`, startX, currentY);
    currentY += 10;

    doc.setFontSize(17);
    doc.setFont(undefined, "bold");
    doc.setTextColor(...green);
    doc.text(fields.holderLabel, startX, currentY);
    currentY += 7;

    doc.setFontSize(13);
    doc.setTextColor(50);
    doc.setFont(undefined, "normal");
    doc.text(
      `Conta: ${sessionStorage.getItem("account") || "--"}`,
      startX,
      currentY,
    );
    currentY += 6;
    doc.text(
      `Agência: ${sessionStorage.getItem("agency") || "--"}`,
      startX,
      currentY,
    );
    currentY += 6;
    doc.text(
      `Titular: ${sessionStorage.getItem("userName") || sessionStorage.getItem("nameUser") || "--"}`,
      startX,
      currentY,
    );
    currentY += 6;
    doc.text(`Chave Pix: ${this.state.pixKey || "--"}`, startX, currentY);

    doc.save("comprovante.pdf");
  }

  /**
   * Na tabela a descrição cai para o nome da contraparte (metadata), que muitas
   * vezes é a única coisa que identifica o lançamento. No comprovante esse nome
   * já aparece na seção do beneficiário, e repeti-lo como descrição deixava a
   * devolução sem dizer o que era.
   */
  formatReceiptDescription(item) {
    if (isRefundEntry(item)) {
      return "Devolução de Pix";
    }

    return this.formatDescription(item) || "Movimentação PIX";
  }

  formatDescription(item) {
    if (
      item.description === "Pedido de transferência pix" &&
      item.transaction_type === "misc"
    )
      return "Taxa de uso da plataforma";
    if (item.metadata !== null && !item.metadata.includes("Bson"))
      return item.metadata;
    else if (
      item.description === "Pedido de transferência pix" &&
      item.transaction_type === "misc"
    )
      return "Taxa de uso da plataforma";

    return item.description;
  }

  getMovementType(movementType) {
    switch (movementType) {
      case "PIXPAYMENTIN":
        return "Pix Payment In";
      case "PIXPAYMENTOUT":
        return "Pix Payment Out";
      case "PIXREVERSALOUT":
        return "Pix Reversal Out";
      case "PIXREVERSALIN":
        return "Pix Reversal In";
      case "WITHDRAW":
        return "Saque";
      case "TRANSFER":
        return "Transferência";
      case "DEPOSIT":
        return "Depósito";

      default:
        return movementType;
    }
  }

  getOperationType(item) {
    if (item.description === "Pedido de transferência ted") return "TED";

    if (item.description === "Estorno de Transferência") return "";

    if (item.transaction_type !== "misc") return "PIX";

    if (item.transaction_type === "misc") return "Transferência interna";

    return "";
  }

  getBalanceType(item) {
    if (
      item.description === "Pedido de transferência pix" &&
      item.transaction_type === "misc"
    )
      return "Tarifa";
    if (item.description === "Estorno de Transferência") return "Estorno";

    switch (`${item.type}`.toUpperCase()) {
      case "CREDIT":
        return "Recebido";
      case "DEBIT":
        return "Emitido";
      case "REFUND":
        return "Devolução";

      default:
        return item.type;
    }
  }

  hasEndToEndId(item) {
    const endToEndId = item?.end_to_end_id || item?.endToEndId;
    return typeof endToEndId === "string"
      ? endToEndId.trim().length > 0
      : Boolean(endToEndId);
  }

  render() {
    const filteredList = Array.isArray(this.props.list)
      ? this.props.list.filter((item) => this.hasEndToEndId(item))
      : [];

    return (
      <section className="TableContent" id="ComponentTable">
        <span className="desktop">
          <table>
            <thead>
              <tr>
                <th style={{ borderRadius: "8px 0px 0px 8px" }}>
                  {this.state.translations.create_date}
                </th>
                <th>{this.state.translations.amount}</th>
                <th>{this.state.translations.last_update_date}</th>
                <th>{this.state.translations.movement_type}</th>
                <th>{this.state.translations.balance_type}</th>
                <th>{this.state.translations.description}</th>
                <th style={{ borderRadius: "0px 8px 8px 0px" }}>Ação</th>
              </tr>
            </thead>
            {filteredList.length > 0 && (
              <tbody>
                {filteredList.map((item, index) => {
                  return (
                    <tr
                      key={index}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        this.openSlideOver(item);
                      }}
                    >
                      <td
                        style={{
                          borderRadius: "8px 0px 0px 8px",
                          textAlign: "center",
                        }}
                      >
                        {this.getDate(item.entry_date)}
                      </td>
                      <td style={{ fontSize: "14px" }}>
                        {this.formatToBRL(item.amount_cents / 100)}
                      </td>
                      <td style={{ fontSize: "14px" }}>
                        {this.getDate(item.entry_date)}
                      </td>

                      <td style={{ fontSize: "14px" }}>
                        <b>{this.getOperationType(item)}</b>
                      </td>
                      <td style={{ fontSize: "14px" }}>
                        <b
                          style={
                            this.getBalanceType(item).includes("Devolução")
                              ? { color: "#2F80ED" }
                              : item.type.toUpperCase().includes("DEBIT")
                                ? this.getBalanceType(item).includes("Tarifa")
                                  ? { color: "#972604ff" }
                                  : { color: "#FF460C" }
                                : this.getBalanceType(item).includes("Estorno")
                                  ? { color: "#8e9e00ff" }
                                  : { color: "#1c787e" }
                          }
                        >
                          {this.getBalanceType(item)}
                        </b>
                      </td>
                      <td style={{ fontSize: "14px" }}>
                        <b>
                          {item.description
                            ? this.formatDescription(item)
                            : item.id}
                        </b>
                      </td>
                      <td style={{ fontSize: "14px", textAlign: "center" }}>
                        <span
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: "10px",
                          }}
                        >
                          {(item.type.toUpperCase().includes("DEBIT") ||
                            item.type.toUpperCase().includes("CREDIT")) && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="#1c787e"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                              <polyline points="7 10 12 15 17 10" />
                              <line x1="12" y1="15" x2="12" y2="3" />
                            </svg>
                          )}
                          {this.renderRefundButton(item)}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            )}
          </table>
        </span>

        <span className="mobile">
          {filteredList.map((item, index) => {
            return (
              <div
                className="contentItemTable"
                key={index}
                onClick={() => this.openSlideOver(item)}
              >
                <div className="contentTitleMobile">
                  <span>
                    <b>
                      {isMtBank() && (
                        <span>
                          <b>PIX</b>
                        </span>
                      )}
                    </b>
                  </span>

                  <span style={{ color: "#696C70" }}>
                    {isMtBank() && (
                      <span>
                        {this.getDate(item.entry_date)}
                        <br />
                      </span>
                    )}
                  </span>
                </div>
                {!isMtBank() && (
                  <div className="row">
                    {this.state.translations.status}
                    <br />
                    <b>{item.status}</b>
                  </div>
                )}
                {isMtBank() && (
                  <div
                    className="row"
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <b>
                      {item.description
                        ? this.formatDescription(item)
                        : item.id}
                    </b>
                  </div>
                )}
                <div
                  className="row"
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>
                    {this.state.translations.value}
                    <br />
                    {isMutual() && <b>{this.formatToBRL(item.amount / 100)}</b>}
                    {isMtBank() && this.formatToBRL(item.amount_cents / 100)}
                  </span>

                  <span>
                    {isMtBank() && (
                      <span>
                        <b
                          style={
                            this.getBalanceType(item).includes("Devolução")
                              ? { color: "#2F80ED" }
                              : item.type.toUpperCase().includes("DEBIT")
                                ? this.getBalanceType(item).includes("Tarifa")
                                  ? { color: "#972604ff" }
                                  : { color: "#FF460C" }
                                : this.getBalanceType(item).includes("Estorno")
                                  ? { color: "#8e9e00ff" }
                                  : { color: "#1c787e" }
                          }
                        >
                          {this.getBalanceType(item)}
                        </b>
                      </span>
                    )}
                  </span>
                </div>
                {canRefund(item) && this.props.onRefund && (
                  <div
                    className="row"
                    style={{ display: "flex", justifyContent: "flex-end" }}
                  >
                    {this.renderRefundButton(item)}
                  </div>
                )}
              </div>
            );
          })}
        </span>
      </section>
    );
  }
}

export default Item;
